module.exports = __webpack_public_path__ + "img/irpf.0f539dd9.png";